module.exports = __webpack_public_path__ + "img/wizard-complete.56eb2b8c.svg";